export default {
  openapi: "3.0.0",
  servers: [
    {
      description: "mea API",
      url: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_V}`,
    },
  ],
  tags: [
    {
      name: "Raster",
    },
    { name: "Vector" },
  ],
  paths: {
    "/mapservices/landbases/tiles/{z}/{x}/{y}": {
      get: {
        tags: ["Vector"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "Tile",
        parameters: [
          {
            in: "query",
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
        ],
        responses: {
          200: {
            description: "successfully retrieved.",
          },
        },
      },
    },
    "/mapservices/landbases/tile-jsons": {
      get: {
        tags: ["Vector"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "Tile json",
        parameters: [
          {
            in: "query",
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
        ],
        responses: {
          200: {
            description: "successfully retrieved.",
          },
        },
      },
    },
    "/mapservices/landbases/styles": {
      get: {
        tags: ["Vector"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "Map Style",
        parameters: [
          {
            in: "query",
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
        ],
        responses: {
          200: {
            description: "successfully retrieved.",
          },
        },
      },
    },
    "/mapservices/landbases/rasters/wms": {
      get: {
        tags: ["Raster"],
        security: [
          {
            ApiKeyAuth: [],
          },
        ],
        summary: "WMS",
        parameters: [
          {
            in: "query",
            name: "api_key",
            description: `หากท่านยังไม่มี API Key [สมัครใช้งานบริการ]( ${process.env.REACT_APP_WEB_URL}/user/register)\n`,
            schema: {
              type: "string",
            },
          },
        ],
        responses: {
          200: {
            description: "successfully retrieved.",
          },
        },
      },
    },
  },
  components: {
    securitySchemes: {
      ApiKeyAuth: {
        type: "apiKey",
        in: "query",
        name: "api_key",
        description: "API Key for Authorization api",
      },
    },
  },
};
